import { c as createSvgIcon } from '../../createSvgIcon-de76dc64.js';
import React from 'react';
import 'tslib';
import '@mui/material/SvgIcon';

var index = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { fill: "none", d: "M0 0h24v24H0V0z" }),
    React.createElement("path", { d: "M11,8V20h2V8h3L12,4,8,8Z" })), 'SortAsc');

export { index as default };
